import * as React from "react";
import { type VariantProps } from "class-variance-authority";
import { Button, buttonVariants } from "../../ui/Button";
import { cn } from "../../../lib/utils";

export interface ButtonSecondaryProps
  extends
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "color">,
    Pick<VariantProps<typeof buttonVariants>, "size"> {
  leadIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
}

function ButtonSecondary({
  className,
  size = "large",
  leadIcon,
  trailingIcon,
  children,
  ref,
  ...props
}: ButtonSecondaryProps & { ref?: React.Ref<HTMLButtonElement> }) {
  return (
    <Button
      variant="secondary"
      size={size}
      className={cn(className)}
      ref={ref}
      {...props}
    >
      {leadIcon && <span className="flex-shrink-0">{leadIcon}</span>}
      {children}
      {trailingIcon && <span className="flex-shrink-0">{trailingIcon}</span>}
    </Button>
  );
}
ButtonSecondary.displayName = "ButtonSecondary";

export { ButtonSecondary };
